module.exports = __webpack_public_path__ + "static/media/lock-top.4ae72904.png";